import { Tr, Td, Input, Button, Box } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { updateCableSubscription, updateDataSubscription, updateEnergySubscription } from '../../service/index';

const DESKTOP = { fontSize: '.68em' };

export const CableSubscriptionTableBody = ({ Data = [] }) => {
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const userId = useSelector((state) => state.auth.user);

  useEffect(() => {
    setSelected(Data);
  }, [Data]);

  const handleSaveCablePrice = async (item) => {
    setLoading(true);
    try {
      await updateCableSubscription(item, setLoading);
    } catch (error) {
      console.error('Error updating cable price:', error);
    }
  };

  return (
    <>
      {selected && (
        <>
          {selected.map((item, i) => {
            return (
              <Tr key={item._id} bg='#fff' {...DESKTOP}>
                <Td>{item?.name}</Td>
                <Td>₦{parseInt(item?.planAmount).toLocaleString()}</Td>
                <Td>
                  <Input
                    size='xs'
                    name='companyAmount'
                    onChange={(e) => {
                      const newSelected = [...selected];
                      newSelected[i] = { ...item, companyAmount: e.target.value };
                      setSelected(newSelected);
                    }}
                    defaultValue={item?.companyAmount}
                    type='number'
                  />
                </Td>
                <Td color={item?.availability === 'Available' ? 'green.500' : 'red.500'}>
                  {item?.availability}
                </Td>
                <Td>
                  <Button
                    size='xs'
                    color='#fff'
                    bg='#FF6F6F'
                    _hover={{ bg: '#FF6F6F' }}
                    _focus={{ boxShadow: 'none' }}
                    onClick={() => handleSaveCablePrice(item)}
                    isLoading={loading}
                    isDisabled={item?.availability !== 'Available'}
                  >
                    Save
                  </Button>
                </Td>
              </Tr>
            );
          })}
        </>
      )}
    </>
  );
};

export const LightSubscriptionTableBody = ({ Data = [] }) => {
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const userId = useSelector((state) => state.auth.user);

  useEffect(() => {
    setSelected(Data);
  }, [Data]);

  const handleSaveEnergyPrice = async (item) => {
    setLoading(true);
    try {
      await updateEnergySubscription(item, setLoading);
    } catch (error) {
      console.error('Error updating energy price:', error);
    }
  };

  return (
    <>
      {selected && (
        <>
          {selected.map((item, i) => {
            return (
              <Tr key={item._id} bg='#fff' {...DESKTOP}>
                <Td>{item?.discoName}</Td>
                <Td>{item?.plan?.toUpperCase()}</Td>
                <Td>₦{parseInt(item?.amount).toLocaleString()}</Td>
                <Td>
                  <Input
                    size='xs'
                    name='companyAmount'
                    onChange={(e) => {
                      const newSelected = [...selected];
                      newSelected[i] = { ...item, companyAmount: e.target.value };
                      setSelected(newSelected);
                    }}
                    defaultValue={item?.companyAmount}
                    type='number'
                  />
                </Td>
                <Td>
                  <Button
                    size='xs'
                    color='#fff'
                    bg='#FF6F6F'
                    _hover={{ bg: '#FF6F6F' }}
                    _focus={{ boxShadow: 'none' }}
                    onClick={() => handleSaveEnergyPrice(item)}
                    isLoading={loading}
                  >
                    Save
                  </Button>
                </Td>
              </Tr>
            );
          })}
        </>
      )}
    </>
  );
};

export const DataSubscriptionTableBody = ({ Data = [] }) => {
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setSelected(Data);
  }, [Data]);

  const handleSaveDataPrice = async (item) => {
    setLoading(true);
    try {
      await updateDataSubscription(item, setLoading);
    } catch (error) {
      console.error('Error updating data price:', error);
    }
  };

  return (
    <>
      {selected && (
        <>
          {selected.map((item, i) => {
            return (
              <Tr key={item._id} bg='#fff' {...DESKTOP}>
                <Td>{item?.name}</Td>
                <Td>₦{parseInt(item?.planAmount).toLocaleString()}</Td>
                <Td>
                  <Input
                    size='xs'
                    name='companyAmount'
                    onChange={(e) => {
                      const newSelected = [...selected];
                      newSelected[i] = { ...item, companyAmount: e.target.value };
                      setSelected(newSelected);
                    }}
                    defaultValue={item?.companyAmount}
                    type='number'
                  />
                </Td>
                <Td>₦{parseInt(item?.companyAmount || item?.planAmount).toLocaleString()}</Td>
                <Td>
                  <Button
                    size='xs'
                    color='#fff'
                    bg='#FF6F6F'
                    _hover={{ bg: '#FF6F6F' }}
                    _focus={{ boxShadow: 'none' }}
                    onClick={() => handleSaveDataPrice(item)}
                    isLoading={loading}
                    isDisabled={!item?.availability || item?.availability !== 'Available'}
                  >
                    Save
                  </Button>
                </Td>
              </Tr>
            );
          })}
        </>
      )}
    </>
  );
};
